import React from 'react'
import { useTranslation } from 'react-i18next'

import starImg from 'src/assets/images/big_star.png'
import { referrals } from 'src/axious/referrals'
import { ButtonSmall, CustomButton } from 'src/components/ui'
import { formattedText } from 'src/utils/formattedText'
import { shareBot } from 'src/utils/shareBot'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import type { ReferralType } from '../ListOfReferrals/ListOfReferrals.types'
import styles from './Referrals.module.scss'
import { NoReferrals, ReferralsList } from './components'

const Referrals = () => {
  const [referralsData, setReferralsData] = React.useState<ReferralType[]>([])
  const [totalAmount, setTotalAmount] = React.useState<number>(0)

  const userId = useGlobalStore((state) => state.user?.id)
  const { t } = useTranslation()

  React.useEffect(() => {
    referrals().then((data) => {
      const referrals = data.map((referral: ReferralType, index: number) => {
        if (index < 6) {
          return referral
        }
      })
      const sorted_referrals = referrals.sort((a: any, b: any) => b.income_stars - a.income_stars)

      setReferralsData(sorted_referrals)
      setTotalAmount(data.reduce((total: number, el: ReferralType) => total + el.income_stars, 0))
    })
  }, [])

  return (
    <>
      <img className={styles.starIcon} src={starImg} alt='Big yellow star' />

      <div className={styles.main}>
        <p className={styles.main_subtitle}>{t('referrals.you_received')}</p>
        <h1 className={styles.main_title}>
          {formattedText(totalAmount)} {t('main_page.stars')}
        </h1>
      </div>

      <div className={styles.footer}>
        {referralsData && (
          <>
            <div className={styles.footer_header}>
              <p className={styles['footer_header-title']}>{t('referrals.my_referrals')}</p>
              <ButtonSmall type='violet' path='/referrals-list' />
            </div>
            <ReferralsList referralsList={referralsData} />
          </>
        )}
        {!referralsData && <NoReferrals />}

        <CustomButton onClick={() => shareBot(userId || 0)} variant='contained' color='violet'>
          {t('referrals.invite_friends')}
        </CustomButton>
      </div>
    </>
  )
}

export default Referrals
